var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15439 8.5L0.350184 15.0295C-0.116728 15.4803 -0.116728 16.2112 0.350185 16.6619C0.817098 17.1127 1.57411 17.1127 2.04103 16.6619L9.64982 9.31619C10.1167 8.86542 10.1167 8.13458 9.64982 7.68381L2.04103 0.338077C1.57411 -0.112692 0.817098 -0.112692 0.350184 0.338078C-0.116729 0.788849 -0.116729 1.51969 0.350184 1.97046L7.15439 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.cf104c511db0a3237cda4b0461f11d15.svg";
export { ForwardRef as ReactComponent };